module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/no_image_ce68548cb31db0831b40d4b81e8d4529.png";